import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router-dom';
import { Alert, ListGroup, ListGroupItem } from 'reactstrap';
import ErrorBoundary from './ErrorBoundary';
import NotAuthenticated from './NotAuthenticated';
import * as Accounts from '../store/Accounts';
import * as paths from '../data/Paths';
import * as Sites from '../store/Sites';
import * as utility from '../data/Utility';

class SelectSiteInternal extends React.Component {
    constructor(props) {
        super(props);

        const createAccount = utility.propCheck(props.createAccount, false);
        const editAccount = utility.propCheck(props.editAccount, false);
        const studyId = utility.propCheck(props.studyId, "");
        const studyName = utility.propCheck(props.studyName, "");
        const userName = utility.propCheck(props.userName, "");
        this.state = {
            createAccount: createAccount,
            editAccount: editAccount,
            linkAccount: createAccount || editAccount,
            studyId: studyId,
            studyName: studyName,
            userName: userName
        };

        this.createListGroup = this.createListGroup.bind(this);
        this.initialize = this.initialize.bind(this);
    }

    componentDidMount() {
        Accounts.checkAuthenticated(this.props.accountsState.authenticated, this.props.accountsDispatch);
        this.initialize(null);
    }

    componentDidUpdate(prevProps) {
        this.initialize(prevProps);
    }

    createListGroup(sites) {
        const listItems = sites.map(site => {
            var to = null;

            if (this.state.createAccount) {
                to = {
                    pathname: paths.createAccount,
                    state: {
                        create: true,
                        linkReturn: true,
                        site: site
                    }
                }
            }
            else if (this.state.editAccount) {
                to = {
                    pathname: paths.account,
                    state: {
                        linkReturn: true,
                        site: site,
                        userName: this.state.userName
                    }
                }
            }
            else {
                to = {
                    pathname: paths.selectRecord,
                    state: {
                        siteId: site.id,
                        siteName: site.name,
                        studyId: this.state.studyId,
                        studyName: this.state.studyName
                    }
                }
            }

            return (
                <ListGroupItem key={site.id} tag={Link} to={to} title={site.name} action>
                    {site.name}
                </ListGroupItem>
            );
        });
        return (
            <ListGroup>
                {listItems}
            </ListGroup>
        );
    }

    initialize(prevProps) {
        const accountsState = this.props.accountsState;
        const authenticated = Accounts.authenticatedAllRoles(accountsState);
        if (Accounts.authenticatedPrevProps(prevProps, authenticated, accountsState.fetching)) {
            if (this.state.linkAccount) {
                this.props.sitesDispatch.getAll();
            }
            else {
                this.props.sitesDispatch.getAllByAuthenticatedUserStudy(this.state.studyId);
            }
        }
    }

    render() {
        if (!Accounts.authenticatedAllRoles(this.props.accountsState)) {
            return (
                <NotAuthenticated />
            );
        }

        var error = false;
        const linkAccount = this.state.linkAccount;
        var message = "";
        var siteList = null;
        var userName = this.state.userName;
        var title = "Select Site";

        const sites = this.props.sitesState.all;
        if (sites != null &&
            sites.length != null &&
            sites.map != null) {
            siteList = this.createListGroup(sites);
            if (sites.length <= 0) {
                if (linkAccount) {
                    message = "No sites exist.";
                }
                else {
                    message = "This study is not linked to any sites.";
                }
            }
        }
        else {
            error = true;
            message = "Error retrieving sites.";
        }

        const alertColor = error ? "danger" : "primary";
        const displayMessage = message !== "";

        if (linkAccount) {
            title = "Link Account";
        }
        if (userName === "") {
            userName = "{empty}";
        }

        return (
            <div>
                <h1>{title} {linkAccount && <small> to account user name '{userName}'</small>}</h1>
                <br />
                {displayMessage && <Alert color={alertColor}>{message}</Alert>}
                {siteList}
            </div>
        );
    }
}

const SelectSiteConnect = connect(
    state => ({
        accountsState: state.accounts,
        sitesState: state.sites
    }),
    dispatch => ({
        accountsDispatch: bindActionCreators(Accounts.actionCreators, dispatch),
        sitesDispatch: bindActionCreators(Sites.actionCreators, dispatch)
    })
)(SelectSiteInternal);

export default class SelectSite extends React.Component {
    render() {
        var createAccount = false;
        var editAccount = false;
        var studyId = "";
        var studyName = "";
        var userName = "";

        const propsState = this.props.location.state;
        if (propsState != null) {
            createAccount = utility.propCheck(propsState.createAccount, createAccount);
            editAccount = utility.propCheck(propsState.editAccount, editAccount);
            studyId = utility.propCheck(propsState.studyId, studyId);
            studyName = utility.propCheck(propsState.studyName, studyName);
            userName = utility.propCheck(propsState.userName, userName);
        }

        return (
            <ErrorBoundary>
                <SelectSiteConnect createAccount={createAccount} editAccount={editAccount} studyId={studyId} studyName={studyName} userName={userName} />
            </ErrorBoundary>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/SelectSite.js